// Store do e-mail da conta — alerta fixo no header até o cliente confirmar o e-mail
import { apiGet, apiPost } from '@/api/conserv';

// { email, confirmado, situacao, podeReenviar, mensagem }. Silencioso: o alerta é opcional e não deve gerar toast de erro
export async function statusEmailConta() {
    return apiGet('api/EmailConta/Status', { silent: true });
}

// Pede o reenvio do link de confirmação para o e-mail da conta (o erro vem em json.msg)
export async function reenviarLinkEmailConta() {
    return apiPost('api/EmailConta/ReenviarLink', {}, { silent: true });
}
